import {Api,handleResponse,handleError} from '../../../../../../api';
//Action
const Actions = {
    Send: 'partner/create-partner',
}


export const apiRequest = {
    create
};

async function create(parent,data) {
    const { onRefresh } = parent.props;
    await new Api().call.post(`${Actions.Send}`, data).then(handleResponse)
        .then(res => {
            parent.setState({
                response:res,
                loading:false
            });
            onRefresh();
        }).catch(error=>{
            if(error!=null && error!==undefined && error.response!==null && error.response!==undefined){
                parent.setState({
                    response:error.response.data,
                    loading:false
                });
            }
            else{
                parent.setState({
                    response:{message:'Váratlan hiba történt',type:'error'},
                    loading:false
                });
            }
            handleError(error);
        });
}